import EzUtils from "@/utils/EzUtils";
import { Constants } from "../components/Constants"

// const storage = weex.requireModule('storage');

/***
 * callback : {result: "result(success/failed)", data: "data"}
 */

export default {
  /***
   *
   * @param key
   * @param value
   *
   * callback : {result: "result(success/failed)", data: "undefined"}
   */
  setItem(key, value) {
    localStorage.setItem(key, value);
    // storage.setItem(key, value, callback => {
    // })
  },

  getItem(key) {
    return localStorage.getItem(key);
    // let returnValue = null;
    // storage.getItem(key, callback => {
    //   if (EzUtils.areEqualString(callback.result, "success", true)) {
    //     returnValue = callback.data;
    //   }
    // });
    // return returnValue;
  },

  removeItem(key) {
    localStorage.removeItem(key);
    // storage.removeItem(key, callback => {
    // })
  },

  length() {
    let length = localStorage.length;
    // let length = 0;
    // storage.length(callback => {
    //   if (EzUtils.areEqualString(callback.result, "success", true)) {
    //     length = callback.data;
    //   }
    // });

    return length;
  },

  getAllKeys() {
    let allKeys = [];
    for (let i = 0; i < localStorage.length; i++) {
      allKeys.push(localStorage.key(i))
    }
    // storage.getAllKeys(callback => {
    //   if (EzUtils.areEqualString(callback.result, "success", true)) {
    //     allKeys = callback.data;
    //   }
    // });

    return allKeys;
  },
};


